import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=b48596e8&scoped=true&"
import script from "./ErrorList.vue?vue&type=script&lang=js&"
export * from "./ErrorList.vue?vue&type=script&lang=js&"
import style0 from "./ErrorList.vue?vue&type=style&index=0&id=b48596e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48596e8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b48596e8')) {
      api.createRecord('b48596e8', component.options)
    } else {
      api.reload('b48596e8', component.options)
    }
    module.hot.accept("./ErrorList.vue?vue&type=template&id=b48596e8&scoped=true&", function () {
      api.rerender('b48596e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Reports/ErrorList.vue"
export default component.exports